import React from "react";
import { CardHeader, CardTitle, Form, Row } from "reactstrap";
import useCurrentSaleStore from "stores/SaleStore";
import LabelAndInput from "./LabelAndInput";
import DMVFee from "./saleComponents/DMVFee";
import NetTrade from "./saleComponents/NetTrade";
import SellerFees from "./saleComponents/SellerFees";
import Taxes from "./saleComponents/Taxes";
import InsuranceAndGAP from "./saleComponents/InsuranceAndGAP";
import ServiceContract from "./saleComponents/ServiceContract";
import Aftermarket from "./saleComponents/Aftermarket";
import DownPayment from "./saleComponents/DownPayment";
import DeferredPickup from "./saleComponents/DeferredPickup";
import { DealStatus } from "constants/Constants";
import useCurrentDealStore from "stores/DealStore";
import TaxCountySelector from "../taxCountySelector/TaxCountySelector";
import formNavigationUtils from "utils/formNavigationUtils";
import shallow from "zustand/shallow";
import ContractInfo from "../dealDetails/ContractInfoDetail";

/**
 * Sale component displays the sale details and inputs for a deal.
 *
 * @returns {JSX.Element} The rendered component
 */
const Sale = () => {
	const {
		price,
		manufacturerRebate,
		editPrice,
		editManufacturerRebate,
		saleType,
	} = useCurrentSaleStore(
		(state) => ({
			price: state.price,
			manufacturerRebate: state.manufacturerRebate,
			editPrice: state.editPrice,
			editManufacturerRebate: state.editManufacturerRebate,
			saleType: state.saleType,
		}),
		shallow
	);

	const { type, taxRegion } = useCurrentDealStore(
		(state) => ({
			type: state.deal.type,
			taxRegion: state?.deal?.dealSettings?.taxDefaults?.taxRegion,
		}),
		shallow
	);

	return (
		<div>
			<CardHeader>
				<CardTitle tag="h3">{type} Deal</CardTitle>
			</CardHeader>
			<div className="card-body pb-3" onKeyDown={formNavigationUtils}>
				<Form className="deal-sale">
					<Row className="align-items-center sale-container">
						<div className="sale-item">
							<LabelAndInput
								name="dealPrice"
								// disable if bulk retail or bulk wholesale or deal is not pending
								disabled={
									saleType === 4 ||
									saleType === 3 ||
									type !== DealStatus.PENDING
								}
								value={price}
								label="Price"
								onChange={editPrice}
								btnClass="w-100 btn-md btn-primary btn"
								buttonLabel="true"
							/>
						</div>
						<div className="sale-item">
							<DMVFee />
						</div>
						<div className="sale-item">
							<SellerFees />
						</div>

						<hr className="mb-3 w-75 mx-auto noDesktop" />

						<div className="sale-item">
							<InsuranceAndGAP />
						</div>
						<div className="sale-item">
							<ServiceContract />
						</div>
						<div className="sale-item">
							<Aftermarket />
						</div>

						<hr className="mb-3 w-75 mx-auto noDesktop" />

						<div className="sale-item">
							<ContractInfo />
						</div>
						<div className="sale-item">
							<NetTrade />
						</div>
						<div className="sale-item">
							<DownPayment />
						</div>

						<hr className="mb-3 w-75 mx-auto noDesktop" />

						<div className="sale-item">
							<LabelAndInput
								name="dealMFR"
								className="text-danger bold"
								disabled={type !== DealStatus.PENDING}
								buttonLabel={true}
								value={manufacturerRebate}
								label="MFR Rebate"
								onChange={editManufacturerRebate}
								sign="-"
								btnClass="w-100 btn-md btn-primary btn px-0"
							/>
						</div>
						<div className="sale-item">
							<DeferredPickup />
						</div>
						<div className="sale-item">
							<Taxes />
						</div>
						<div className="col-12 p-0">
							<hr className="my-2 w-75 mx-auto" />
							<TaxCountySelector localTaxRegion={taxRegion} />
						</div>
					</Row>
				</Form>
			</div>
		</div>
	);
};

export default Sale;
